  <div class="h-100 text-center col-12">
    <div class="d-table w-100 h-100 ">
      <div class="d-table-cell align-middle">
        <div *ngIf="(content_visibility?.display === contentVisibility.MASKING) || communityVisible">
          <img
            
            class="mb-1 d-inline-block lock-icon"
            src="assets/images/masking-lock.svg"
          />
          <div>
            <p class="heading-4 ">
              <span>{{ mls?.languageText?.product_masking?.key1}}<span *ngIf="mls?.is_lskey_display == 1">(product_masking.key1)</span></span>
            </p>
            <p class=" secondary-paragraph">
              <span *ngIf="!communityVisible">{{ content_visibility?.verify_title }}</span>
              <span *ngIf="communityVisible">{{ mls?.languageText?.product_masking?.key3}}</span>
            </p>
          </div>
          <div>
            <button class="btn-design small filled" (click)="showWebModal('verify_step1')">
              <span *ngIf="!communityVisible">{{ content_visibility?.verify_msg}}</span>
              <span *ngIf="communityVisible">{{ mls?.languageText?.product_masking?.key4}}</span>
            </button>
          </div>
        </div>

        <div
          *ngIf="content_visibility?.display === contentVisibility.SUBMITTED"
        >
          <img
            
            class="mb-1 d-inline-block lock-icon"
            src="assets/images/masking-lock.svg"
          />

          <div>
            <p class="heading-4 ">
              {{ mls?.languageText?.product_masking?.key2
              }}<span *ngIf="mls?.is_lskey_display == 1"
                >(product_masking.key2)</span
              >
            </p>
            <p class=" secondary-paragraph">
              {{ content_visibility?.verify_msg }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>